import React, { useContext, useEffect, useState } from 'react';
import CONSTANTS from '../utils/constants';
import { UUIDContext } from "../UUIDContexted";

interface PaylaDcsProps {
  snippetToken: string;
  agreed: boolean;
}

const PaylaDcs: React.FC<PaylaDcsProps> = ({ snippetToken, agreed }) => {

  const PBLData = useContext(UUIDContext);
  const partnerMerchantId = PBLData ? PBLData.bnplId : '';
  const currentUrl = window.location.origin;
  let environment = "t"; // Set to "t" for test environment, "p" for production

  const [hasPaylaDscRun, setHasPaylaDscRun] = useState(false);

  if (currentUrl === CONSTANTS.PROD_URL) {
    environment = "p"; // Set to "p" for production environment
  }

  useEffect(() => {
    if (agreed && !hasPaylaDscRun) {
      executePaylaDsc();
      setHasPaylaDscRun(true);
    }
  }, [agreed]);

  // When component unmounts, remove the script and CSS link
  useEffect(() => {
    return () => {
      document.getElementById('paylaDcs')?.remove();
      document.getElementById('paylaDcsCss')?.remove();
    };
  }, []);

  const executePaylaDsc = () => {

    const script = document.createElement('script');
    script.src = `https://d.payla.io/dcs/${CONSTANTS.PAYLA_PARTNER_ID}/${partnerMerchantId}/dcs.js`;
    script.type = 'text/javascript';
    script.id = 'paylaDcs';
    script.onload = () => {
      if (window.paylaDcs) {
        window.paylaDcs.init(environment, snippetToken);
      }
    };
    document.body.appendChild(script);

    const link = document.createElement('link');
    link.id = 'paylaDcsCss';
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `https://d.payla.io/dcs/dcs.css?st=${snippetToken}&pi=${CONSTANTS.PAYLA_PARTNER_ID}&psi=${partnerMerchantId}&e=${environment}`;
    document.head.appendChild(link);
  }

  return <div id="payla-dcs-container" />;
};

export default PaylaDcs;
